import { useState } from 'react';

import TimesIcon from 'public/icons/alert_close.svg';
import AlertIcon from 'public/icons/alert.svg';
import styles from 'styles/Alert.module.css';

export type AlertProps = {
  title?: string;
  message: string;
  onClose?: () => void;
  variant: 'white' | 'error' | 'success' | 'warning';
  className?: string;
};

export default function Alert({
  title,
  message,
  onClose,
  variant,
  className,
}: AlertProps) {
  const [open, setOpen] = useState(true);

  const _onClose = () => {
    setOpen(false);

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <div
      className={`${styles.alert} ${styles[variant]} ${
        open && styles.open
      } ${className}`}
    >
      <div className={styles.alert__content}>
        <div className={styles.content__icon__wrap}>
          <AlertIcon />
        </div>
        <p className={styles.content__text}>{message}</p>
        {onClose && (
          <div className={styles.content__times__wrap} onClick={_onClose}>
            <TimesIcon />
          </div>
        )}
      </div>
    </div>
  );
}
